import { render, staticRenderFns } from "./safetyAccidentReport.vue?vue&type=template&id=fad8cbe8&scoped=true&"
import script from "./safetyAccidentReport.vue?vue&type=script&lang=js&"
export * from "./safetyAccidentReport.vue?vue&type=script&lang=js&"
import style0 from "./safetyAccidentReport.vue?vue&type=style&index=0&id=fad8cbe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad8cbe8",
  null
  
)

export default component.exports